import React from 'react';
import { Link } from 'react-router-dom';
import { Edit2 } from 'lucide-react';
import { Engagement } from '../../types/engagement';

const EngagementStatusBadge: React.FC<{ status: Engagement['status'] }> = ({ status }) => {
  const colors = {
    draft: 'bg-gray-500/20 text-gray-300',
    active: 'bg-green-500/20 text-green-300',
    stopped: 'bg-red-500/20 text-red-300',
  };

  return (
    <span className={`px-2 py-1 text-xs font-medium rounded-full ${colors[status]}`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

interface EngagementListProps {
  engagements: Engagement[];
  onEdit?: (engagement: Engagement) => void;
}

export const EngagementList: React.FC<EngagementListProps> = ({ engagements, onEdit }) => {
  return (
    <div className="bg-dark-700 rounded-lg overflow-hidden">
      <ul className="divide-y divide-dark-600">
        {engagements.map((engagement) => (
          <li key={engagement.id} className="hover:bg-dark-600">
            <div className="px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="min-w-0 flex-1">
                  <Link
                    to={`/engagements/${engagement.id}`}
                    className="block focus:outline-none"
                  >
                    <div className="flex items-center space-x-3">
                      <p className="text-sm font-medium text-white truncate">
                        {engagement.title}
                      </p>
                      <EngagementStatusBadge status={engagement.status} />
                    </div>
                    {engagement.description && (
                      <p className="mt-1 text-sm text-gray-400 truncate">
                        {engagement.description}
                      </p>
                    )}
                  </Link>
                </div>
                <div className="ml-4 flex items-center space-x-4">
                  {engagement.deadline && (
                    <span className="text-sm text-gray-400">
                      Due {new Date(engagement.deadline).toLocaleDateString()}
                    </span>
                  )}
                  {onEdit && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        onEdit(engagement);
                      }}
                      className="text-gray-400 hover:text-white"
                    >
                      <Edit2 className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
